import $ from "jquery";

// Popups per [popup="<id>"] link (manual opening)
export function init(id) {

	var $newPopup = $('#'+$.escapeSelector(id));

	if (!$newPopup.length) return;

	if (!$newPopup.hasClass('popup--opened')) {
		var id = $newPopup.prop('id');
		$('body').on('click', '[popup="'+id+'"]', function(e) {
			e.preventDefault();
			$('body').css('overflow','hidden');
			$newPopup.removeClass('popup--closed').addClass('popup--opened');
		});
		$newPopup.on('click', '.popup-close', function(e) {
			e.preventDefault();
			$('body').css('overflow','');
			$newPopup.removeClass('popup--opened').addClass('popup--closed');
		});
		$newPopup.addClass('popup--opened');
	}
}

// CTA popups with configurable triggers: show the first matching popup once per browser session
export function initAll() {

	var $popup = $();

	$('.popup[data-config]').each(function() {
		var config = parseConfig($(this).attr('data-config'));
		if (config && isEligible($(this).prop('id'), config)) {
			$popup = $(this);
			trigger($popup, config);
			return false;
		}
	});
}

function parseConfig(json) {
	try {
		return JSON.parse(json);
	} catch (e) {
		return null;
	}
}

function isEligible(id, config) {

	var now = Date.now();

	if (config.from && now < config.from) return false;
	if (config.until && now > config.until) return false;

	if (!matchesPage(config)) return false;
	if (!matchesQuery(config.query)) return false;

	try {
		if (sessionStorage.getItem('popup:'+id)) return false;
	} catch (e) {}

	return true;
}

function matchesPage(config) {

	if (config.pagemode !== 'include' && config.pagemode !== 'exclude') return true;

	// compare with and without language prefix (/en/blog/... and /blog/...)
	var paths = [location.pathname, location.pathname.replace(/^\/[a-z]{2}(\/|$)/, '/')];
	var matches = config.pagepatterns.some(function(pattern) {
		var regex = new RegExp('^' + pattern.split('*').map(escapeRegex).join('.*') + '$');
		return paths.some(function(path) {
			return regex.test(path) || regex.test(path.replace(/(.)\/$/, '$1'));
		});
	});

	return config.pagemode === 'include' ? matches : !matches;
}

function matchesQuery(entries) {

	var params = new URLSearchParams(location.search);

	return entries.every(function(entry) {
		var parts = entry.split('=');
		var key = parts.shift().trim();
		if (!params.has(key)) return false;
		return !parts.length || params.get(key) === parts.join('=').trim();
	});
}

function escapeRegex(string) {
	return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// open the popup as soon as all enabled triggers are met
function trigger($popup, config) {

	var id = $popup.prop('id');
	var ns = '.popup-' + id;
	var timer;
	var delayMet = !config.delay;
	var scrollMet = !config.scroll;

	function open() {
		if ($('.wmBox_overlay').is(':visible')) {
			timer = setTimeout(open, 1000);
			return;
		}
		$(window).off(ns);
		clearTimeout(timer);
		try {
			sessionStorage.setItem('popup:'+id, '1');
		} catch (e) {}
		$popup.addClass('popup--opened');
		$popup.on('click', '.popup-close', function(e) {
			e.preventDefault();
			$popup.removeClass('popup--opened').addClass('popup--closed');
		});
	}

	function check() {
		if (delayMet && scrollMet) open();
	}

	function checkScroll() {
		var scrollable = $(document).height() - $(window).height();
		var percent = scrollable > 0 ? $(window).scrollTop() / scrollable * 100 : 100;
		if (percent >= config.scrollpercent) {
			scrollMet = true;
			check();
		}
	}

	function startDelay() {
		clearTimeout(timer);
		timer = setTimeout(function() {
			delayMet = true;
			check();
		}, config.delayseconds * 1000);
	}

	if (config.delay) {
		startDelay();
		if (config.delaymode === 'inactivity') {
			$(window).on('scroll'+ns+' click'+ns+' keydown'+ns+' mousemove'+ns, function() {
				if (!delayMet) startDelay();
			});
		}
	}

	if (config.scroll) {
		$(window).on('scroll'+ns, checkScroll);
		checkScroll();
	}

	check();
}
